// this object provides values for slide controls <testing>

var slider_controls = {
  items_fw: 5,
  transition: "fade",
  loop: true,
};

// MOBILE SEARCH FORM //
$('#responsive-search-icon').on('click', function () {
  $('.mobile-sf-wrapper').css('display', 'block');
  $('.mobile-sf-wrapper').addClass('fade-reveal');
})

$('#mobile-sf-close').on('click', function () {
  $('.mobile-sf-wrapper').css('display', 'none');
})

// DESKTOP SEARCH TRIGGER //

$('div.site-footer__item:nth-child(2) > div:nth-child(1) > div:nth-child(2) > p:nth-child(3)').on('click', function () {
  $('.mobile-sf-wrapper').css('display', 'block');
  $('.mobile-sf-wrapper').addClass('fade-reveal');
})

// PRODUCT GALLERY IMAGE SWAPPING //
// $('.product-tn-img').click(function() {
//     var fbg = $('.product-fp-img').attr('src');
//     var bg = $(this).attr('src');
//     $('.product-fp-img').attr("src", bg);
//     $(this).attr("src", fbg);
// });

// CUSTOM PRODUCT FEATURE IMAGE MAGNIFICATION //


// SLIDE CONFIG - OWL //
$(document).ready(function () {
  $('#owl-cl').owlCarousel({
    transitionStyle: slider_controls.transition,
    loop: slider_controls.loop,
    margin: 10,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        nav: false,
      },
      600: {
        items: 3,
        nav: false,
      },
      1000: {
        items: slider_controls.items_fw,
        nav: false,
      }
    }
  });

  $('#owl-fp').owlCarousel({
    items: 6,
    transitionStyle: "fade",
    loop: true,
    margin: 10,
    autoplay: true,
    autoplayTimeout: 7000,
    autoplayHoverPause: true,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 6,
      }
    }
  });

  $('#owl-thumbs').each(function (index) {
    var items_no = $(this).data('slides');
    $(this).owlCarousel({
      transitionStyle: "fade",
      loop: true,
      margin: 10,
      responsive: {
        0: {
          items: 1,
          nav: false,
        },
        600: {
          items: items_no,
          nav: false,
        },
        1000: {
          items: items_no,
          nav: false,
        }
      }
    });
  });

  // HOMEPAGE PAGER FUNCTION //
  $('.ajax-call').on('click', function (e) {
    e.preventDefault();
    if ($('.ajax-call').hasClass('active-tab')) {
      $('.ajax-call').removeClass('active-tab')
    }
    $(this).toggleClass('active-tab');
    var collection_name = this.attributes.data.value.substr(1);
    ajax_fp_populate(collection_name);
  });

  $(".mobile-pf-tabs").change(function () {
    var collection_name = this.value.replace(/ /g, "-").toLowerCase();
    ajax_fp_populate(collection_name);
  });

  function ajax_fp_populate(collection_name) {
    var request = new XMLHttpRequest();
    request.open('GET', '/?section_id=hp-fp-' + collection_name + "-test", true);
    request.send();
    request.onloadend = function () {
      var newHTML = request.responseText;
      var owlFP = $(newHTML).html();
      $('#owl-fp').replaceWith(owlFP);
      $('#owl-fp').owlCarousel({
        items: 6,
        transitionStyle: "fade",
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 7000,
        autoplayHoverPause: true,
        nav: false,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 3,
          },
          1000: {
            items: 6,
          }
        }
      });
    };
    return false;
  };

  // USED FOR PRODUCT PAGER ON PRODUCT PAGES //
  $('.ajax-call-product').on('click', function (e) {
    e.preventDefault();
    if ($('.ajax-call-product').hasClass('active-tab')) {
      $('.ajax-call-product').removeClass('active-tab')
    }
    $(this).toggleClass('active-tab');
    var pane_name = 'bb-product-' + this.attributes.data.value.substr(1);
    $('#' + pane_name).removeClass('bb-hide').siblings().addClass('bb-hide');
  });
  $(".bb-mobile-pager-tabs").change(function () {
    var pane_name = 'bb-product-' + this.value.replace(/ /g, "-").toLowerCase();
    $('#' + pane_name).removeClass('bb-hide').siblings().addClass('bb-hide');
  });

  // USED TO TOGGLE VAT ON PRODUCT PAGES //
  $('#vat_checked').click(function () {
    $('.vat-indi-toggle').toggleClass('bb-brand-highlight');
    $('.price_and_vat').toggleClass('bb-hide');
  });

  // USED TO SHORTEN COLLECTION DESCRIPTION ON COLLECTION PAGE, REDUCE WRAPPER SIZE //
  $('.desc_toggle').on('click', function () {
    $('.c_d_w').toggleClass("short long");
    if ($('.c_d_w').hasClass("long")) {
      $(this).html('&#8722;');
    } else {
      $(this).html('&#43;');
    }
    ;
  });

  // source ordering for about us page
  var js_media = $(window).width();
  if (js_media <= 639) {
    $('#js-src-target-1').addClass('small-order-2')
    $('#js-src-target-2').addClass('small-order-1')
  } else {
    $('#js-src-target-1').removeClass('small-order-2')
    $('#js-src-target-2').removeClass('small-order-1')
  }

  setTimeout(function () {
    // Ensure the mobile menu redirects to the URL.
    // Fixes issue where "After Dinner Mints" link in mobile doesn't redirect to the link.
    $('.mm_menus_li ul.ets_mm_categories a, .mm_menus_li ul.ets_mm_pages a').each(function () {
      $(this).on('click', function () {
        var href = $(this).attr('href');
        if (typeof(href) != 'undefined') {
          location.href = this.href;
        }
      });
    });

    // Fix "text" on who bought.
    var fix_also_bought = ($('#who-bought-widget-wrap h2.cbb-also-bought-title').text()).replace('this also bought', 'this');
    $('#who-bought-widget-wrap h2.cbb-also-bought-title').text(fix_also_bought);

    // Change £0.00 to "Get A Quote" in "Also Bought" block.
    $('li.cbb-also-bought-product span.cbb-also-bought-product-regular-price .money').each(function () {
      var price = $(this).text();
      // Check indexOf == 1 to ensure we're checking exactly on 0.00 only
      if (price.indexOf('0.00') == 1) {
        $(this).text('Get A Quote');
      }
    });
  }, 500);

  // This is used to address multiple inline links that redirect to the old site, they normally occur in product description
  if ($('#bb-product-product-description ul li a').attr('href') == '/customised-products-how-it-works/') {
    $('#bb-product-product-description ul li a').attr('href', '/pages/how-it-works');
  }

  // This was a quick fix for American speeling differences
  $('p').each(function () {
    var text = $(this).text();
    var culprit_array = ['personalized', 'personalization'];
    if ($.inArray(text, culprit_array) > -1) {
      $(this).text(text.replace('personalized', 'personalised'));
      $(this).text(text.replace('personalization', 'personalisation'));
    }
  });

  //Update subscribe to newsletter link so the hashtag is removed.
  var newsletter_action = $('#ContactFooter').attr('action');
  var newsletter = newsletter_action.replace('#ContactFooter', '');
  $('#ContactFooter').attr('action', newsletter);

  // Change modal heading depending on which button was clicked to trigger it.
  $('.bb-product-question a.btn-ghost, .bb-made-to-order-links a.btn-ghost').on('click', function () {
    var get_class = $(this).parent().attr('class');
    var header_text = $('#ex1 h3').text();
    var heading = (get_class.indexOf('bb-product-question') >= 0) ? 'Ask a question.' : header_text;
    $('#ex1 h3').text(heading);
  });

  // THIS SCRIPT ADDRESSES A BUG WITH MEGA MENU CLASS ALLOCATION //
  var mm_media = $(window).width();
  if (mm_media <= 1024) {
    $('#nav-wrapper > div > div').addClass('changestatus');
    console.log(mm_media);
  }
});
